// i18n area 'networks' — locale en-GB (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da networks.en-US.ts e sovrascrive SOLO le chiavi
// che l'inglese britannico scrive davvero in un altro modo — una chiave nuova
// nella base arriva qui gratis, e la parità si misura su base + delta.
// Contenuto: ortografia britannica (-ise/-isation, 'licence' sostantivo,
// 'catalogue', 'centre', 'enrolment') e le poche differenze lessicali reali.
// Token che NON sono prosa (il riferimento catalog/<catalog>/<file>@<digest>,
// il permesso catalog.download) restano tali e quali.
// Sidecar anti-stantie: ../meta/networks.en-GB.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './networks'

export const enGB: DeepPartial<typeof enUS> = {
  networks: {
    services: {
      ntp: {
        mode: 'Synchronisation mode',
        modeHint: 'Relay serves time taken from the declared upstream servers; the node\'s own clock serves the serving node\'s time — which the cluster keeps synchronised anyway'
      }
    }
  }
}
